export const defaultTheme = {
    theme: "custom",
    font: "Roboto",
    colors: {
        portrait: {
            base: {
                background: "#414B55E6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
        },
        mainAction: {
            base: {
                background: "#414B55E6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
            hover: {
                background: "#747e88e6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
        },
        bonusAction: {
            base: {
                background: "#453B75E6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
            hover: {
                background: "#9288c2e6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
        },
        freeAction: {
            base: {
                background: "#3B5875E6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
            hover: {
                background: "#88a5c2e6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
        },
        reaction: {
            base: {
                background: "#753B3BE6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
            hover: {
                background: "#c28888e6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
        },
        endTurn: {
            base: {
                background: "#374B3CE6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
            hover: {
                background: "#849889e6",
                color: "#B4D2DCFF",
                border: "#757f89FF",
            },
        },
        tooltip: {
            header: {
                background: "#ffffffCC",
                color: "#414146",
                border: "#757f89FF",
            },
            subtitle: {
                background: "#32505a",
                color: "#ffffff",
                border: "#757f89FF",
            },
            body: {
                background: "#5a7896B3",
                color: "#ffffff",
                border: "#757f89FF",
            },
        },
        abilityMenu: {
            background: "#414B55E6",
            color: "#B4D2DCFF",
            border: "#757f89FF",
            base: { color: "#B4D2DCFF", boxShadow: "#757f89CC" },
            hover: { color: "#B4D2DCFF", boxShadow: "#757f89CC" },
        },
        buttons: {
            base: {
                background: "#5096c3",
                color: "#ffffff",
                border: "#5096c3",
            },
            hover: {
                background: "#55bef5",
                color: "#ffffffff",
                border: "#55bef5",
            },
        },
        movement: {
            used: { background: "#7d879180", boxShadow: "#00000000" },
            baseMovement: { background: "#5abef5FF", boxShadow: "#6ed2ffCC" },
            dashMovement: { background: "#c8c85aFF", boxShadow: "#dcdc6eCC" },
            dangerMovement: { background: "#c85f5aFF", boxShadow: "#dc736eCC" },
        },
    },
};

export function initConfig() {
    Handlebars.registerHelper("echLocalize", (data, data2, data3) => {
        let str = `.${data}`;
        if (typeof data2 == "string") str += `${data2.charAt(0).toUpperCase() + data2.slice(1)}`;
        if (typeof data3 == "string") str += `${data3.charAt(0).toUpperCase() + data3.slice(1)}`;

        return game.i18n.localize(`enhancedcombathud.themeOptions${str}`);
    });

    Handlebars.registerHelper("ifObject", function (item, options) {
        if (typeof item === "object") {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });
}